import angular from 'angular';
import uiRouter from 'angular-ui-router';
import ItemTemplateComponent from './item-template.component';

let ItemTemplateModule = angular.module('ItemTemplate', [
    uiRouter
])

.config(($stateProvider) => {
    'ngInject';
    $stateProvider
        .state('newItemTemplate', {
            url: '/itemTemplates/new',
            component: 'itemTemplate',
            parent: 'main',
            data: {
                permissions: {
                    only: ['ADMIN'],
                    redirectTo: 'home'
                }
            },
            resolve: {
            }
        })
        .state('editItemTemplate', {
            url: '/itemTemplates/:id',
            component: 'itemTemplate',
            parent: 'main',
            data: {
                permissions: {
                    only: ['ADMIN'],
                    redirectTo: 'home'
                }
            },
            resolve: {
                itemTemplate: (
                    ItemTemplatesService,
                    $stateParams
                ) => {
                    return ItemTemplatesService.findOne({
                        filter: {
                            where: {
                                id: $stateParams.id
                            },
                            include: [],
                            deleted: true
                        }
                    });
                }
            }
        });
})
.component('itemTemplate', ItemTemplateComponent)
.name;

export default ItemTemplateModule;
